import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Order from './pages/Order';
import Contact from './pages/Contact';
import CakeDetail from './pages/CakeDetail';
import { SettingsProvider } from './context/SettingsContext';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import AdminCakeList from './admin/AdminCakeList';
import AdminCakeNew from './admin/AdminCakeNew';
import AdminCakeEdit from './admin/AdminCakeEdit';
import AdminSettings from './admin/AdminSettings';
import AdminChangePassword from './admin/AdminChangePassword';
import NotFound from './pages/NotFound';

// Renders the storefront chrome (Navbar + WhatsApp bubble) everywhere except
// the admin dashboard, which has its own sidebar/layout.
function StorefrontChrome({ cartCount }) {
  const location = useLocation();
  if (location.pathname.startsWith('/admin')) return null;
  return (
    <>
      <Navbar cartCount={cartCount} />
    </>
  );
}

function FloatingWhatsApp() {
  const location = useLocation();
  if (location.pathname.startsWith('/admin')) return null;
  return <WhatsAppButton />;
}

function App() {
  const [cart, setCart] = useState([]);

  const addToCart = (cake) => {
    setCart(prev => {
      const exists = prev.find(item => item.id === cake.id);
      if (exists) {
        return prev.map(item =>
          item.id === cake.id ? { ...item, qty: item.qty + 1 } : item
        );
      }
      return [...prev, { ...cake, qty: 1 }];
    });
  };

  const removeFromCart = (id) => {
    setCart(prev => prev.filter(item => item.id !== id));
  };

  const updateQty = (id, qty) => {
    if (qty < 1) return removeFromCart(id);
    setCart(prev => prev.map(item => item.id === id ? { ...item, qty } : item));
  };

  return (
    <SettingsProvider>
      <Router>
        <ScrollToTop />
        <StorefrontChrome cartCount={cart.reduce((s, i) => s + i.qty, 0)} />
        <Routes>
          <Route path="/" element={<Home addToCart={addToCart} />} />
          <Route path="/order" element={<Order cart={cart} removeFromCart={removeFromCart} updateQty={updateQty} />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cake/:id" element={<CakeDetail addToCart={addToCart} />} />

          {/* ── Admin (full CRUD control over cakes, pricing, delivery, password) ── */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/cakes" element={<AdminCakeList />} />
          <Route path="/admin/cakes/new" element={<AdminCakeNew />} />
          <Route path="/admin/cakes/:id" element={<AdminCakeEdit />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/change-password" element={<AdminChangePassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <FloatingWhatsApp />
      </Router>
    </SettingsProvider>
  );
}

export default App;

// ScrollToTop component: ensures the window scrolls to top on route changes.
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
